import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "modal-title",
    class: "text-xl font-semibold text-gray-900 dark:text-white"
};
const _hoisted_2 = { class: "space-y-4" };
const _hoisted_3 = { class: "text-base leading-relaxed text-gray-500 dark:text-gray-400" };
const _hoisted_4 = ["for"];
const _hoisted_5 = ["id", "placeholder", "disabled"];
const _hoisted_6 = { class: "mt-2 text-sm text-gray-500 dark:text-gray-400" };
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { Modal, Button, Alert } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CancelSubscriptionModal',
    props: {
        isOpen: { type: Boolean },
        subscriptionId: {},
        shopperReference: {},
        merchantReference: {},
        isLoading: { type: Boolean, default: false }
    },
    emits: ["close", "confirm"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const cancellationReason = ref("");
        const isModalOpen = computed({
            get: () => props.isOpen,
            set: () => handleClose(),
        });
        const canSubmit = computed(() => {
            return cancellationReason.value.trim().length > 0 && !props.isLoading;
        });
        const handleClose = () => {
            if (!props.isLoading) {
                cancellationReason.value = "";
                emit("close");
            }
        };
        const handleConfirm = () => {
            if (canSubmit.value) {
                emit("confirm", cancellationReason.value.trim());
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isModalOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isModalOpen).value = $event)),
                size: "sm",
                "data-testid": "cancel-subscription-modal",
                dismissable: false,
                "close-on-escape": !__props.isLoading,
                onClose: handleClose
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancel.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('dashboard.subscriptions.modal.buttons.cancel'),
                        disabled: __props.isLoading,
                        "data-testid": "cancel-modal-btn",
                        onClick: handleClose
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        variant: "error",
                        label: _unref(t)('dashboard.subscriptions.modal.cancel.confirmButton'),
                        loading: __props.isLoading,
                        disabled: !canSubmit.value,
                        "data-testid": "submit-cancel-btn",
                        onClick: handleConfirm
                    }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Alert), {
                            color: "warning",
                            heading: _unref(t)('dashboard.subscriptions.modal.cancel.warning.title'),
                            message: _unref(t)('dashboard.subscriptions.modal.cancel.warning.message')
                        }, null, 8 /* PROPS */, ["heading", "message"]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancel.description", {
                            merchantReference: props.merchantReference,
                        })), 1 /* TEXT */),
                        _createElementVNode("div", null, [
                            _createElementVNode("label", {
                                for: `cancellation-reason-${__props.subscriptionId}`,
                                class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            }, [
                                _createTextVNode(_toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancel.reasonLabel")) + " ", 1 /* TEXT */),
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-red-600 dark:text-red-500" }, "*", -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_4),
                            _withDirectives(_createElementVNode("textarea", {
                                id: `cancellation-reason-${__props.subscriptionId}`,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((cancellationReason).value = $event)),
                                rows: "4",
                                "data-testid": "cancellation-reason-textarea",
                                class: "block w-full p-2.5 text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                placeholder: _unref(t)('dashboard.subscriptions.modal.cancel.reasonPlaceholder'),
                                disabled: __props.isLoading,
                                required: ""
                            }, null, 8 /* PROPS */, _hoisted_5), [
                                [_vModelText, cancellationReason.value]
                            ]),
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancel.reasonHint")), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "close-on-escape"]));
        };
    }
});
